/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {environment} from '../environments/environment';

@Component({
  selector: 'ngx-app',
  template: `
    <div id="mode-maintenance" *ngIf="modeMaintenance"><p class="mb-0">Estamos en mantenimiento</p></div>
    <router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  modeMaintenance = false

  constructor() {
  }

  ngOnInit(): void {
    this.modeMaintenance = environment.modeMaintenance
  }
}
